import { Link } from "react-router-dom";
import { specials } from "@/mocks/specials";

export default function SpecialEntry() {
  return (
    <div className="space-y-3">
      {specials.slice(0, 4).map((topic) => (
        <Link
          key={topic.id}
          to="/special"
          className="group flex gap-3 rounded-lg border border-background-200 bg-background-50 p-2.5 transition-colors hover:border-accent-300"
        >
          <span className="block h-16 w-20 shrink-0 overflow-hidden rounded-md bg-background-200">
            <img
              src={topic.poster}
              alt={`${topic.title} 专题海报 - 棒棒TV`}
              title={`${topic.title} - 棒棒TV专题`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block truncate text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
              {topic.title}
            </span>
            <span className="mt-1 block truncate text-xs text-foreground-500">
              {topic.subtitle}
            </span>
            <span className="mt-1.5 inline-flex items-center gap-1 text-xs font-medium text-accent-600">
              {topic.movieIds.length} 部作品
              <i className="ri-arrow-right-s-line"></i>
            </span>
          </span>
        </Link>
      ))}
    </div>
  );
}